import React, { useState, useEffect } from 'react';
import { loadFaceSVG } from '../emotions/faceAssets';

/**
 * FaceHalf Component
 * Renders a single half (left or right) of an emotion face SVG
 */
const FaceHalf = ({ emotion, side, size = 156, className = '' }) => {
  const [svgContent, setSvgContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    
    loadFaceSVG(emotion, side)
      .then(svg => {
        setSvgContent(svg);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(`Error loading ${emotion} ${side} face:`, err);
        setError(err);
        setIsLoading(false);
      });
  }, [emotion, side]);

  // SVGs are 156x312 (1:2 aspect ratio), so height is 2x width
  const height = size * 2;

  if (isLoading) {
    return (
      <div 
        className={`face-half-loading ${className}`}
        style={{ width: '100%', height: '100%' }}
      />
    );
  }

  if (error || !svgContent) {
    return (
      <div 
        className={`face-half-error ${className}`}
        style={{ width: '100%', height: '100%' }}
      />
    );
  }

  return (
    <div 
      className={`face-half ${className}`}
      style={{ width: '100%', height: '100%' }}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default FaceHalf;

